import React from 'react';
import PropTypes from 'prop-types';
import PartnerDeploymentMetrics from '../PartnerDeploymentMetrics';
import PartnerCenterIntegration from '../PartnerCenterIntegration';
import PartnerQueueClients from '../PartnerQueueClients';

const PartnerClientsTab = ({ history, location }) => {
  return (
    <>
      <PartnerDeploymentMetrics />

      <PartnerCenterIntegration />

      <PartnerQueueClients history={history} location={location} />
    </>
  );
};

PartnerClientsTab.propTypes = {
  history: PropTypes.objectOf(PropTypes.any),
  location: PropTypes.objectOf(PropTypes.any)
};

PartnerClientsTab.defaultProps = {
  history: {},
  location: {}
};

export default PartnerClientsTab;
